import Sales from 'dash/js/services/Sales'
import SalesHelper from 'dash/js/helpers/SalesHelper'
import FilterStruct from 'dash/js/schemas/filters.struct'
import { redirectToCheckout } from 'dash/js/plugins/cart'

/**
 * @param commit
 * @param rootState
 * @param rootGetters
 * @param dispatch
 * @param data
 */
export const retrieveSales = async ({ commit, rootGetters }, data) => {
  let params = data ? data : FilterStruct

  let filters = Object.assign(params, { by: 'created-between',  type: 'sales' })

  Sales.retrieve(filters, response => {
    SalesHelper.verifySales(response.data, { clients: rootGetters['clients/clients'] }, response => commit('retrieveSales', response))
  })
}

/**
 * @param {*} param0
 * @param {*} data
 */
export const editSale = ({ commit, }, data) => commit('editSale', data)

/**
 * @param commit
 * @param dispatch
 * @param sale
 */
export const updateSale = ({ commit }, sale) => {
  Sales.update(sale.id, sale, response => {
    commit('updateSale', response.data)

    SalesHelper.validate(sale, async response => {
      let payload = await SalesHelper.calculate(response.data)

      commit('updateSale', payload)
    })
  })
}

/**
 * @param state
 * @param content
 */
export const insertIntoCart = ({ state, commit }, content) => {
  Promise.all(SalesHelper.generatePromises(state.sales, content)).then(async responses => {
    responses.forEach(id => {
      commit('updateDisabledStatus', id)
    })
  })
}

/**
 * @param state
 * @param content
 */
export const addAndPay = ({ state }, content) => {
  Promise.all(SalesHelper.generatePromises(state.sales, content)).then(async responses => {
    await redirectToCheckout(responses)
  })
}

/**
 *
 * @param commit
 * @param state
 * @param data
 */
export const selectCotation = ({ commit, state }, data) => {
  commit('selectCotation', data)

  let { id, cotation } = data

  let sale = state.sales.find(item => {
    if (item.id === id) {
      return item
    }
  })

  Object.assign(sale.options, {default_shipping: parseInt(cotation.id)})

  Sales.update(sale.id, sale, response => {
    SalesHelper.validate(sale, response => commit('updateSale', response.data))
  })
}

/**
 * @param commit
 * @param data
 */
export const archive = ({ commit }, sale) => {
  Sales.archive(sale.id, response => {
    commit('removeSale', sale.id)
  })
}

/**
 * @param commit
 * @param state
 * @param data
 */
export const pushItemIntoArray = ({ commit }, data) => commit('pushItemIntoArray', data)

/**
 * @param commit
 * @param data
 */
export const popItemFromArray = ({ commit }, data) => commit('popItemFromArray', data)

/**
 * @param commit
 */
export const cleanArray = ({ commit }) => commit('cleanArray')

/**
 * @param dispatch
 * @param state
 * @param vm
 */
export const checkboxMaster = ({ dispatch, state }, { vm }) => {
  let childrens = vm.$children.filter(child => child.$options._componentTag === 'mv-sales-item')

  if (state.selectedSales.length === 0) {
    state.sales.forEach(item => {
      if (!item.disabled) {
        dispatch('pushItemIntoArray', item.id)

        SalesHelper.markCheckboxes(childrens, item.id, true)
      }
    })

    return
  }

  dispatch('cleanArray')

  state.sales.forEach(item => {
    SalesHelper.markCheckboxes(childrens, item.id, false)
  })
}
